/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import cookieStorage from "../../cookieStorage";
import {
  Button,
  Col,
  Form,
  Row,
  Spinner,
  Container,
  Dropdown,
} from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useBetween } from "use-between";
import qs from "query-string";

import { Item, Toggle } from "../../components";
import { CloseIcon } from "../../components/icons";
import CartLayout from "../../layout/CartLayout";
import { useAuthApi, useCartApi, useCatalogApi } from "../useApi";

import "./index.scss";
import InfiniteScroll from "./InfiniteScroll";
import ProductsLoader from "../../components/products-loader";
import ProductsTabularLoader from "../../components/products-loader/ProductsTabularLoader";

const productAvailability = [
  { id: "new-release", label: "New" },
  { id: "limited-product", label: "Limited Supply" },
  { id: "fast-movers", label: "Fast Movers" },
];

function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Collection = () => {
  const params = useParams();
  const cBrand = params.brand;
  const navigate = useNavigate();
  const pageSize = 100;
  const [sortByValue, setSortByValue] = useState("random");
  const [pageNum, setPageNum] = useState(1);
  const [isTileView, setIsTileView] = useState(
    cookieStorage.getItem("isTileView")
      ? JSON.parse(cookieStorage.getItem("isTileView"))
      : true,
  );
  const [totalCount, setTotalCount] = useState(0);
  const [status, setStatus] = useState(false);
  const [localBrands, setLocalBrands] = useState([]);

  const setView = (status) => {
    setIsTileView(status);
    cookieStorage.setItem("isTileView", JSON.stringify(status));
  };

  const query = useQuery();
  const location = useLocation();

  const {
    products,
    updating,
    categories,
    phenotypes,
    setProducts,
    setUpdating,
    getProductsCategories,
    getProducts,
    getFavorite,
    getAllBrands,
    getProductByContent,
  } = useBetween(useCatalogApi);
  const { customerId, logout, customer } = useBetween(useAuthApi);
  const { cart } = useBetween(useCartApi);

  const cartQtyByProductId = React.useMemo(() => {
    const map = {};
    (cart.products || []).forEach((p) => {
      map[p.productId] = p.quantity;
    });
    return map;
  }, [cart.products]);

  const getFiltersFromQuery = React.useCallback(() => {
    return {
      availability: query.get("availability")
        ? query.get("availability").split(",")
        : [],
      brand: query.get("brand") ? query.get("brand").split(",") : [],
      category: query.get("category") ? query.get("category").split(",") : [],
      taste: query.get("taste") ? query.get("taste").split(",") : [],
      terpine: query.get("terpine") ? query.get("terpine").split(",") : [],
      phenotype: query.get("phenotype")
        ? query.get("phenotype").split(",")
        : [],
      effect: query.get("effect") ? query.get("effect").split(",") : [],
      subcategory: query.get("subcategory")
        ? query.get("subcategory").split(",")
        : [],
    };
  }, [query]);

  const {
    availability: availabilityFilters,
    brand: brandFilters,
    category: categoryFilters,
    taste: tasteFilters,
    terpine: terpineFilters,
    phenotype: phenotypeFilters,
    effect: effectFilters,
    subcategory: subFilters,
  } = React.useMemo(() => getFiltersFromQuery(), [getFiltersFromQuery]);

  const updateQuery = (
    availability,
    brand,
    category,
    subCategory,
    taste,
    terpine,
    phenotype,
    effect,
    sortByValue,
  ) => {
    const newQueryParam = {
      availability: availability.join(","),
      brand: brand.join(","),
      category: category.join(","),
      subcategory: subCategory.join(","),
      taste: taste.join(","),
      terpine: terpine.join(","),
      phenotype: phenotype.join(","),
      effect: effect.join(","),
      sort: sortByValue,
    };
    setPageNum(1);
    setProducts([]);

    navigate(`/collection/${cBrand}?${qs.stringify(newQueryParam)}`);
  };

  useEffect(() => {
    getProductsCategories().catch((err) => {
      console.log("err", err);
    });
    getAllBrands()
      .then((response) => {
        if (response.type === "success" && response.brands.length > 0) {
          let filteredBrands = response.brands
            .filter((brand) => {
              // Handle multiple possible structures
              const brandName = brand.Name?.value || brand.Name || brand;
              const finalName =
                typeof brandName === "object" ? brandName.value : brandName;
              return Boolean(finalName);
            })
            .map((brand) => {
              // Extract brand name handling multiple structures
              let brandName = brand.Name?.value || brand.Name || brand;
              // If it's still an object with a value property, extract that
              if (typeof brandName === "object" && brandName?.value) {
                brandName = brandName.value;
              }
              // Ensure we return a string
              return typeof brandName === "string"
                ? brandName
                : String(brandName);
            });

          if (!customer["710:CustomerID"] && !customer["710:Enabled"]) {
            filteredBrands = filteredBrands.filter(
              (brand) => brand !== "710 Labs",
            );
          }

          if (filteredBrands.length === 0) return setLocalBrands([]);

          setLocalBrands(filteredBrands);
        }
      })
      .catch(() => console.log("err"));
  }, []);

  useEffect(() => {
    getFavorite(customerId);
  }, [customerId]);

  useEffect(() => {
    setStatus(false);

    setProducts([]);
    setUpdating(true);

    const isAllBrand = cBrand === "all";

    const currentFilters = getFiltersFromQuery();

    const pageNumber = Object.values(currentFilters).some((f) => f.length > 0)
      ? pageNum
      : 1;

    const fetchPromise = isAllBrand
      ? getProducts(
        currentFilters.availability,
        currentFilters.brand,
        currentFilters.category,
        currentFilters.subcategory,
        currentFilters.taste,
        currentFilters.terpine,
        currentFilters.phenotype,
        currentFilters.effect,
        sortByValue,
        pageNumber,
        pageSize,
      )
      : getProductByContent(cBrand);

    fetchPromise
      .then((res) => {
        setTotalCount(res.count);
        setPageNum(pageNum + 1);
        setStatus(true);
      })
      .catch(() => logout())
      .finally(() => {
        setUpdating(false);
      });
  }, [location.search, cBrand]);

  const activeFilters = React.useMemo(() => {
    return [
      ...availabilityFilters.map((id) => ({
        type: "availability",
        label: productAvailability.find((a) => a.id === id)?.label || id,
        value: id,
      })),
      ...brandFilters.map((val) => ({ type: "brand", label: val, value: val })),
      ...categoryFilters.map((val) => ({
        type: "category",
        label: val,
        value: val,
      })),
      ...subFilters.map((val) => ({
        type: "subcategory",
        label: val,
        value: val,
      })),
      ...terpineFilters.map((val) => ({
        type: "terpine",
        label: val,
        value: val,
      })),
      ...tasteFilters.map((val) => ({ type: "taste", label: val, value: val })),
      ...phenotypeFilters.map((val) => ({
        type: "phenotype",
        label: val,
        value: val,
      })),
      ...effectFilters.map((val) => ({
        type: "effect",
        label: val,
        value: val,
      })),
    ];
  }, [
    availabilityFilters,
    brandFilters,
    categoryFilters,
    subFilters,
    terpineFilters,
    tasteFilters,
    phenotypeFilters,
    effectFilters,
  ]);

  const loadMoreProducts = () => {
    const maxPagination = totalCount / pageSize + 1;
    if (!status || pageNum > maxPagination) {
      return false;
    }

    setStatus(false);
    const currentFilters = getFiltersFromQuery();

    getProducts(
      currentFilters.availability,
      currentFilters.brand,
      currentFilters.category,
      currentFilters.subcategory,
      currentFilters.taste,
      currentFilters.terpine,
      currentFilters.phenotype,
      currentFilters.effect,
      sortByValue,
      pageNum,
      pageSize,
    )
      .then((res) => {
        setStatus(true);
        setPageNum(pageNum + 1);
      })
      .catch(() => logout());
  };

  const toggleFilter = (type, value) => {
    const current = getFiltersFromQuery();
    const keyMap = {
      availability: "availability",
      brand: "brand",
      category: "category",
      taste: "taste",
      terpine: "terpine",
      phenotype: "phenotype",
      effect: "effect",
      subcategory: "subcategory",
    };

    const key = keyMap[type];
    let nextFilters = [...current[key]];

    if (nextFilters.includes(value)) {
      nextFilters = nextFilters.filter((item) => item !== value);
    } else {
      nextFilters.push(value);
    }

    const allFilters = {
      ...current,
      [key]: nextFilters,
      ...(type === "category" ? { subcategory: [] } : {}),
    };

    updateQuery(
      allFilters.availability,
      allFilters.brand,
      allFilters.category,
      allFilters.subcategory,
      allFilters.taste,
      allFilters.terpine,
      allFilters.phenotype,
      allFilters.effect,
      sortByValue,
    );
  };

  const handleResetFilter = () => {
    updateQuery([], [], [], [], [], [], [], [], "");
  };

  // Ensure brands are always strings before rendering
  const safebrands = React.useMemo(() => {
    const result = localBrands.map((brand) => {
      if (typeof brand === "string") return brand;
      if (typeof brand === "object" && brand !== null) {
        let extracted = brand.Name?.value || brand.Name || brand.value || brand;
        if (
          typeof extracted === "object" &&
          extracted !== null &&
          extracted.value
        ) {
          extracted = extracted.value;
        }
        const result =
          typeof extracted === "string" ? extracted : String(extracted);
        return result;
      }
      return String(brand);
    });

    return result;
  }, [localBrands]);

  // Ensure phenotypes are always strings before rendering
  const safePhenotypes = React.useMemo(() => {
    return phenotypes.map((phenotype) => {
      if (typeof phenotype === "string") return phenotype;
      if (typeof phenotype === "object" && phenotype !== null) {
        return phenotype.value || String(phenotype);
      }
      return String(phenotype);
    });
  }, [phenotypes]);

  // Ensure categories and subcategories are safe to render
  const safeCategories = React.useMemo(() => {
    const result = {};
    Object.keys(categories).forEach((categoryKey) => {
      const category = categories[categoryKey];
      const safeCategoryKey =
        typeof categoryKey === "object" && categoryKey?.value
          ? categoryKey.value
          : typeof categoryKey === "string"
            ? categoryKey
            : String(categoryKey);

      result[safeCategoryKey] = {
        ...category,
        subCategories:
          category.subCategories?.map((subCat) => {
            if (typeof subCat === "string") return subCat;
            if (typeof subCat === "object" && subCat !== null) {
              return subCat.value || String(subCat);
            }
            return String(subCat);
          }) || [],
      };
    });
    return result;
  }, [categories]);

  // Ensure products have safe Phenotype fields for rendering
  const safeProducts = React.useMemo(() => {
    return products.map((product) => {
      // Extract Phenotype as a string
      let phenotypeValue = product.Phenotype;
      if (typeof phenotypeValue === "object" && phenotypeValue !== null) {
        phenotypeValue = phenotypeValue.value || String(phenotypeValue);
      }

      return {
        ...product,
        Phenotype:
          typeof phenotypeValue === "string"
            ? phenotypeValue
            : String(phenotypeValue || ""),
      };
    });
  }, [products]);

  return (
    <CartLayout>
      <div className="w-100 has-sidebar pt-5 pb-4">
        <Container>
          <div className="page-header">
            <h3>All Products</h3>
          </div>
          {cBrand == "all" && (
            <Row className="filter-bar">
              <Col sm={9} md={10}>
                <ul className="filter-items-wrapper">
                  {productAvailability.map((availability) => (
                    <li className="filter-column" key={availability.id}>
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        className={
                          availabilityFilters.includes(availability.id)
                            ? `active ${availability.id}`
                            : `${availability.id}`
                        }
                        onClick={() =>
                          toggleFilter("availability", availability.id)
                        }
                      >
                        {availability.label}
                      </Button>
                    </li>
                  ))}
                  <li className="filter-column">
                    <Dropdown className="filter-dropdown" autoClose="outside">
                      <Dropdown.Toggle variant="outline-dark" size="sm">
                        Brand
                        <span className="ms-1">
                          {brandFilters.length > 0 &&
                            `[${brandFilters.length}]`}
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu renderOnMount={true}>
                        {!status && (
                          <div className="filter-loader">
                            <Spinner size="sm" />
                          </div>
                        )}
                        {safebrands.map((brand, index) => (
                          <Dropdown.Item
                            as="div"
                            key={brand}
                            className="py-0 ps-3 pe-0 filter-dropdown-item"
                          >
                            <Form.Check
                              key={index}
                              type="checkbox"
                              id={`brand-checkbox-${index}`}
                              label={brand}
                              name="brand"
                              value={brand}
                              checked={brandFilters.includes(brand)}
                              className="d-block"
                              onChange={(e) =>
                                toggleFilter("brand", e.target.value)
                              }
                            />
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </li>
                  <li className="filter-column">
                    <Dropdown className="filter-dropdown" autoClose="outside">
                      <Dropdown.Toggle variant="outline-dark" size="sm">
                        Phenotype
                        <span className="ms-1">
                          {phenotypeFilters.length > 0 &&
                            `[${phenotypeFilters.length}]`}
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu renderOnMount={true}>
                        {!status && (
                          <div className="filter-loader">
                            <Spinner size="sm" />
                          </div>
                        )}
                        {safePhenotypes.length
                          ? safePhenotypes.map((phenotype, index) => (
                            <Dropdown.Item
                              as="div"
                              key={index}
                              className="py-0 ps-3 pe-0 filter-dropdown-item"
                            >
                              <Form.Check
                                key={index}
                                type="checkbox"
                                id={`pheno-checkbox-${index}`}
                                label={phenotype}
                                name="phenotype"
                                value={phenotype}
                                checked={phenotypeFilters.includes(phenotype)}
                                onChange={(e) =>
                                  toggleFilter("phenotype", e.target.value)
                                }
                              />
                            </Dropdown.Item>
                          ))
                          : null}
                      </Dropdown.Menu>
                    </Dropdown>
                  </li>

                  <li className="filter-column">
                    <Dropdown className="filter-dropdown" autoClose="outside">
                      <Dropdown.Toggle variant="outline-dark" size="sm">
                        Category
                        <span className="ms-1">
                          {categoryFilters.length > 0 &&
                            `[${categoryFilters.length}]`}
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu renderOnMount={true}>
                        {!status && (
                          <div className="filter-loader">
                            <Spinner size="sm" />
                          </div>
                        )}
                        {Object.keys(safeCategories).length
                          ? Object.keys(safeCategories).map(
                            (category, index) =>
                              safeCategories[category].available ? (
                                <Dropdown.Item
                                  as="div"
                                  key={index}
                                  className="py-0 ps-3 pe-0 filter-dropdown-item"
                                >
                                  <Form.Check
                                    type="checkbox"
                                    id={`category-checkbox-${index}`}
                                    label={category}
                                    name="category"
                                    value={category}
                                    className=""
                                    checked={categoryFilters.includes(
                                      category,
                                    )}
                                    onChange={(e) => {
                                      toggleFilter(
                                        "category",
                                        e.target.value,
                                      );
                                    }}
                                  />
                                </Dropdown.Item>
                              ) : null,
                          )
                          : null}
                      </Dropdown.Menu>
                    </Dropdown>
                  </li>
                  {categoryFilters.length > 0 && (
                    <li className="filter-column">
                      <Dropdown
                        className={`filter-dropdown`}
                        autoClose="outside"
                      >
                        <Dropdown.Toggle
                          variant="outline-dark"
                          size="sm"
                          disabled={!(categoryFilters.length > 0)}
                        >
                          Type
                        </Dropdown.Toggle>

                        <Dropdown.Menu renderOnMount={true}>
                          {!status && (
                            <div className="filter-loader">
                              <Spinner size="sm" />
                            </div>
                          )}
                          {Object.keys(safeCategories).length
                            ? Object.keys(safeCategories).map(
                              (category, index) =>
                                safeCategories[category].available ? (
                                  <Dropdown.Item
                                    as="div"
                                    key={index}
                                    className="py-0 px-0 filter-dropdown-item"
                                  >
                                    <div className="menu-category-name px-3 py-2">
                                      {category}
                                    </div>
                                    {safeCategories[category].subCategories
                                      .sort()
                                      .reverse()
                                      .map((subCategory, index) => (
                                        <Dropdown.Item
                                          as="div"
                                          key={index}
                                          className="py-0 ps-3 pe-0 filter-dropdown-item"
                                        >
                                          <Form.Check
                                            key={index}
                                            type="checkbox"
                                            id={`sub-checkbox-${index}`}
                                            label={subCategory}
                                            name="subcategory"
                                            value={subCategory}
                                            className=""
                                            checked={subFilters.includes(
                                              subCategory,
                                            )}
                                            onChange={(e) =>
                                              toggleFilter(
                                                "subcategory",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </Dropdown.Item>
                                      ))}
                                  </Dropdown.Item>
                                ) : null,
                            )
                            : null}
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  )}
                  {(availabilityFilters.length > 0 ||
                    brandFilters.length > 0 ||
                    categoryFilters.length > 0 ||
                    phenotypeFilters.length > 0 ||
                    subFilters.length > 0) && (
                      <li className="filter-column">
                        <Button
                          size="sm"
                          variant="outline-danger"
                          className="reset-button"
                          onClick={() => handleResetFilter()}
                        >
                          Reset
                        </Button>
                      </li>
                    )}
                </ul>
              </Col>
              <Col sm={3} md={2}>
                <Toggle status={isTileView} setStatus={setView} />
              </Col>
            </Row>
          )}

          <Row>
            <Col lg={12} className="bg-white d-flex flex-column">
              <div className="collection-container">
                {activeFilters.length > 0 && (
                  <div className="collection-fil tags-wrapper">
                    <div>
                      {activeFilters.map((filter, index) => (
                        <span
                          className="filter-item"
                          key={`${filter.type}-${filter.value}-${index}`}
                          onClick={() => {
                            toggleFilter(filter.type, filter.value);
                          }}
                        >
                          <span>{filter.label}</span>
                          <CloseIcon width="14" height="14" />
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                <div className="products-wrapper">
                  {isTileView ? (
                    <Row>
                      {safeProducts.length
                        ? safeProducts.map((product, index) => (
                          <Col
                            key={`${product._id}-${index}`}
                            lg={2}
                            md={3}
                            xs={6}
                          >
                            <Item
                              style={isTileView}
                              product={product}
                              cartQty={
                                cartQtyByProductId[
                                  product.InventoryID?.value
                                ] || 0
                              }
                            />
                          </Col>
                        ))
                        : null}
                      {!status && <ProductsLoader />}
                      {safeProducts.length <= 0 && status && (
                        <h6>No product available!</h6>
                      )}
                    </Row>
                  ) : (
                    <div className="product-table">
                      <div className="table-header">
                        <span className="table-cell title-img d-flex align-items-center">
                          <span className="me-3 d-sm-block d-none"></span>
                          <span>Products</span>
                        </span>
                        <span className="table-cell d-md-block d-none potency">
                          THC %
                        </span>
                        <span className="table-cell d-lg-block d-none">
                          Unit Price
                        </span>
                        <span className="table-cell size d-xl-block d-none">
                          Case Size
                        </span>
                        <span className="table-cell">Case Price</span>
                        <span className="table-cell add-cta me-0">Add</span>
                      </div>
                      {safeProducts.length
                        ? safeProducts.map((product, index) => (
                          <Item
                            key={`${product._id}-${index}`}
                            style={isTileView}
                            product={product}
                            cartQty={
                              cartQtyByProductId[
                                product.InventoryID?.value
                              ] || 0
                            }
                          />
                        ))
                        : null}

                      {!status && <ProductsTabularLoader />}
                      {safeProducts.length <= 0 && status && (
                        <h6>No product available!</h6>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <InfiniteScroll onIntersect={loadMoreProducts} />
      </div>
      {/* {!status ? (
                <div className='page-loading'>
                    <Spinner animation='border' role='status'>
                        <span className='visually-hidden'>Loading...</span>
                    </Spinner>
                </div>
            ) : null} */}
      {/* {updating ? (
                <div className='update-loading'>
                    <Spinner animation='border' role='status'>
                        <span className='visually-hidden'>Loading...</span>
                    </Spinner>
                </div>
            ) : null} */}
      {/* <ScrollToTop /> */}
    </CartLayout>
  );
};

export default Collection;
